"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactLottie = _interopRequireDefault(require("react-lottie"));

var _warningSign = _interopRequireDefault(require("./warningSign.json"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//Material-ui
var WarningSign = function WarningSign(_ref) {
  var callback = _ref.callback,
      label = _ref.label;
  return _react["default"].createElement("div", null, _react["default"].createElement(_reactLottie["default"], {
    options: {
      loop: false,
      autoplay: true,
      animationData: _warningSign["default"],
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    },
    height: 150,
    width: 150,
    isStopped: false,
    isPaused: false
  }), _react["default"].createElement(_Typography["default"], {
    color: "inherit",
    align: "center",
    variant: "h6"
  }, label), _react["default"].createElement(_Button["default"], {
    color: "secondary",
    fullWidth: true,
    onClick: callback
  }, "continuar"));
};

var _default = WarningSign;
exports["default"] = _default;